import React from "react";
import { ResponsiveNetworkCanvas } from '@nivo/network'

class NetworkChart extends React.Component {
    render() {
        const { data } = this.props;
        return (
            <ResponsiveNetworkCanvas
                data={data}
                links={data.links}
                nodes={data.nodes}
                margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                linkDistance="distance"
                repulsivity={4}
                iterations={60}
                nodeColor={function (t) { return t.color }}
                nodeBorderWidth={1}
                nodeBorderColor={{ theme: 'background' }}
            />
        )
    }
}

export default NetworkChart;